export const getDataTablePt = () => ({
  table: {
    class: "min-w-full bg-white",
  },
  header: {
    class: "w-12 border-b border-gray-275 bg-gray-30",
  },
  headerRow: {
    class: "bg-gray-30",
  },
  column: {
    bodycell: (props) => {
      let base = "p-4 border-b border-gray-275 cursor-pointer text-black font-medium text-sm transition-colors duration-200";
      if (props.context.index === 1) {
        base = 'p-4 border-b border-gray-275 text-teal-900 font-medium text-sm transition-colors duration-200 cursor-pointer';
      }
      return { class: base };
    },
  },
});

export const getHeaderPt = () => ({
  headerCell: {
    class: "font-semibold text-sm leading-[1.5] !text-black font-medium text-sm transition-colors duration-200",
  },
});

export const getCheckboxStyles = (props) => ({
  root: {
    "data-testid": "checkbox",
    class: "relative inline-flex align-bottom w-5 h-5 cursor-pointer select-none",
  },
  input: {
    class:
      "peer w-5 h-5 absolute top-0 left-0 z-10 p-0 m-0 opacity-0 rounded-md outline-none border-2 border-surface-200 dark:border-surface-700 appearance-none cursor-pointer",
  },
  box: {
    class: `border border-black transition-colors duration-200 rounded-none h-5 w-5 flex items-center justify-center ${
      props.context.checked ? "bg-black text-white" : "bg-white"
    }`,
  },
});

export const getColumnPt = () => ({
  headerCell: {
    class: "bg-gray-30",
  },
  rowCheckbox: getCheckboxStyles,
  headerCheckbox: getCheckboxStyles,
});

export const getCalendarPt = () => ({
  panel: {
    class:
      "absolute w-auto border rounded-lg shadow-md bg-white dark:bg-surface-800 border-indigo-base dark:border-surface-700",
  },
  header: {
    class:
      "font-semibold flex items-center justify-between p-2 m-0 border-b rounded-t-md text-indigo-base dark:text-white/80 bg-teal-accent dark:bg-surface-800 dark:border-surface-700",
  },
  group: {
    class: "flex-1 border-l border-surface-200 pt-0 pb-0 first:pl-0 first:border-l-0",
  },
});

export const getSliderPt = () => ({
  root: { class: "relative h-1 w-60 border-0 bg-gray-275 dark:bg-surface-700" },
  range: { class: "block absolute top-0 left-0 h-full bg-indigo-base dark:bg-primary-400" },
  startHandler: {
    class:
      "block h-[1.143rem] w-[1.143rem] top-[50%] mt-[-0.5715rem] ml-[-0.5715rem] rounded-full border-3 bg-white dark:bg-surface-600 border-indigo-base dark:border-primary-400 hover:bg-primary-500 hover:border-primary-500 focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring focus-visible:ring-primary-400/50 dark:focus-visible:ring-primary-300/50 transition duration-200 cursor-grab touch-action-none",
  },
  endHandler: {
    class:
      "block h-[1.143rem] w-[1.143rem] top-[50%] mt-[-0.5715rem] ml-[-0.5715rem] rounded-full border-3 bg-white dark:bg-surface-600 border-indigo-base dark:border-primary-400 hover:bg-primary-500 hover:border-primary-500 focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring focus-visible:ring-primary-400/50 dark:focus-visible:ring-primary-300/50 transition duration-200 cursor-grab touch-action-none",
  },
});
